/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Meta_DescInputs */

const en_wc_on_meta_desc = /** @type {(inputs: Wc_On_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use WordCraft online for free. Our WebAssembly build includes multilingual fonts and runs in your browser. No install, no account, documents stay on your device.`)
};

/**
* | output |
* | --- |
* | "Use WordCraft online for free. Our WebAssembly build includes multilingual fonts and runs in your browser. No install, no account, documents stay on your dev..." |
*
* @param {Wc_On_Meta_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_meta_desc = /** @type {((inputs?: Wc_On_Meta_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Meta_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_meta_desc(inputs)
});
export { wc_on_meta_desc as "wc.on.meta_desc" }